export const repositoryName = 'self-checkout'
export const releaseID = ''
export const defaultLocale = 'en-us'
export const locales = ['en-us', 'sv-se', 'en-se', 'no-no', 'en-no', 'fi-fi', 'en-fi']
export const timezones: { [key: string]: string } = {
  se: 'Europe/Stockholm',
  fi: 'Europe/Helsinki',
  no: 'Europe/Oslo',
  us: 'Europe/Stockholm',
}
